import { IStore } from '../../index';
import { IAlertNotification, IMessageNotification, INotificationsStore } from '../store';
import { TOmitFirstArg } from '../../Interfaces/OmitFirstArg';

type TPushNotificationActionWithState = (
  state: IStore,
  newNotification: IAlertNotification | IMessageNotification
) => { notifications: INotificationsStore };

export const push: TPushNotificationActionWithState = (state, newNotification) => {
  if (newNotification.type === 'alert') {
    return {
      notifications: {
        ...state.notifications,
        alert: newNotification,
        open: 'alert'
      }
    };
  }

  return {
    notifications: {
      ...state.notifications,
      message: newNotification,
      open: 'message'
    }
  };
};

export type TPushNotificationAction = TOmitFirstArg<TPushNotificationActionWithState>;
